import { render, staticRenderFns } from "./CampaignHistoryOverview.vue?vue&type=template&id=47e1e5a9&scoped=true&"
import script from "./CampaignHistoryOverview.vue?vue&type=script&lang=js&"
export * from "./CampaignHistoryOverview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignHistoryOverview.vue?vue&type=style&index=0&id=47e1e5a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1e5a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VCardTitle,
  VContainer,
  VLayout,
})
